export const frontmatter = {
    "draft": false,
    "title": "Contactos",
    "sidebar_group": "referencia",
    "sidebar_label": "Contactos",
    "sidebar_order": 6
}

export const toc = []